import ArtistPillButton from "components/buttons/ArtistPillButton";

const ARTIST_PILL_BUTTON_EXAMPLE = (
  <ArtistPillButton
    src="images/landing/katherine-profile.jpg"
    name="petrichorate"
  />
);

export default ARTIST_PILL_BUTTON_EXAMPLE;
